import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import { BeatLoader } from 'react-spinners';
import {
    getRepairSimilarArtistName,
    getSyncronizeArtistData,
    deleteArtist,
    getAddArtistDataAsync,
    runDataCleanupAsync,
    postGenerateEmbeddings,
    postVectorSearchArtist,
} from "../../components/apis/music-api";
import { postSearchForArtistRequest } from "../../types/messages/PostSearchForArtistRequest";

const Admin = () => {
    const { getAccessToken } = useContext(AuthenticationContext);

    const [ oldName, setOldName ] = useState<string>();
    const [ newName, setNewName ] = useState<string>();
    const [ fixing, setFixing ] = useState(false);
    const [ similarArtists, setSimilarArtists ] = useState<string[]>([]);

    const [ syncArtist, setSyncArtist ] = useState<string>('');
    const [ syncing, setSyncing ] = useState(false);
    const [ synchronizeCount, setSynchronizeCount ] = useState(0);
    const [ addingArtistData, setAddingArtistData ] = useState(false);
    const [ addArtistDataCount, setAddArtistDataCount ] = useState(0);
    const [ generatingEmbeddings, setGeneratingEmbeddings ] = useState(false);
    
    // const [ compSyncing, setCompSyncing ] = useState(false);
    // const [ compSynchronizeCount, setCompSynchronizeCount ] = useState(0);
    
    const [ dataCleanupRunning, setDataCleanupRunning ] = useState(false);

    const [ delLetter, setDelLetter ] = useState<string>('');
    const [ delArtist, setDelArtist ] = useState<string>('');
    const [ deleting, setDeleting ] = useState(false);
    const [ deleteCount, setDeleteCount ] = useState(0);

    // const [ addingTrackDuration, setAddingTrackDuration ] = useState(false);
    // const [ addTrackDurationCount, setAddTrackDurationCount ] = useState(0);
        
    // https://www.last.fm/api/auth?api_key=740e3df4cc3eedb94d4654677a292567
    
    const generateEmbeddingsAsync = async () => {
        setGeneratingEmbeddings(true);
        await postGenerateEmbeddings(getAccessToken());
        setGeneratingEmbeddings(false);
    }
        
    const postVectorSearchArtistAsync = async (artistName: string) => {
        setGeneratingEmbeddings(true);
        const data: postSearchForArtistRequest = { artistName: artistName };
        const result = await postVectorSearchArtist(getAccessToken(), data);
        setGeneratingEmbeddings(false);
    }

    const fixSimilarArtistNameAsync = async () => {
        if (oldName !== undefined && newName !== undefined) {
            const result = await getRepairSimilarArtistName(getAccessToken(), oldName, newName);
            setSimilarArtists(result);
            setFixing(false);
        }
    }

    const submitFixSimilarArtistNameAsync = () => {
        setSimilarArtists([]);
        setFixing(true);
        fixSimilarArtistNameAsync();
    }

    const syncronizeArtistData = async () => {
        const result = await getSyncronizeArtistData(getAccessToken(), syncArtist);
        setSyncing(false);
        setSynchronizeCount(result);
    }

    const submitSyncronizeArtistData = () => {
        setSyncing(true);
        syncronizeArtistData();
    }

    // const syncronizeCompilationData = async () => {
    //     const result = await getSyncronizeCompilationData(getAccessToken());
    //     setCompSyncing(false);
    //     setCompSynchronizeCount(result);
    // }

    const addArtistData = async () => {
        const result = await getAddArtistDataAsync(getAccessToken());
        setAddingArtistData(false);
        setAddArtistDataCount(result);
    }

    const submitAddArtistData = () => {
        setAddingArtistData(true);
        addArtistData();
    }

    // const submitSyncronizeCompilationData = () => {
    //     setCompSyncing(true);
    //     syncronizeCompilationData();
    // }

    const runDataCleanup = async () => {
        setDataCleanupRunning(true);
        await runDataCleanupAsync(getAccessToken());
        setDataCleanupRunning(false);
    }
    
    const deleteArtistData = async () => {
        const result = await deleteArtist(getAccessToken(), delArtist);
        setDeleting(false);
        setDeleteCount(result);
    }

    const submitDeleteArtistData = () => {
        setDeleting(true);
        deleteArtistData();
    }

    const submitGenerateEmbeddings = () => {
        setGeneratingEmbeddings(true);
        //generateEmbeddingsAsync();
        postVectorSearchArtistAsync("Nirvana");
    }

    return (
        <>
            <Stack spacing={2}>
                <Box>
                    <Typography variant='h5'>Administration</Typography>
                </Box>
            </Stack>
            <Stack spacing={3} direction="row">
                <Box>
                    <Stack spacing={1}>
                        <Box>
                            <Typography variant='h6'>Generate Embeddings</Typography>
                        </Box>
                        <Box>
                            <Button variant="contained" disabled={generatingEmbeddings} onClick={submitGenerateEmbeddings}>Submit</Button>
                        </Box>
                        <Box>
                            <BeatLoader
                                loading={generatingEmbeddings}
                                size={24}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </Box>
                    </Stack>
                </Box>
            </Stack>
            <Stack spacing={3} direction="row">
                <Box>
                    <Stack spacing={1}>
                        <Box>
                            <Typography variant='h6'>Add Artist Data</Typography>
                        </Box>
                        <Box>
                            <Button variant="contained" disabled={addingArtistData} onClick={submitAddArtistData}>Submit</Button>
                        </Box>
                        <Box>
                            {addArtistDataCount === 0 ? '' : addArtistDataCount}
                            <BeatLoader
                                loading={addingArtistData}
                                size={24}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </Box>
                    </Stack>
                </Box>
                <Box>
                    <Stack spacing={1}>
                        <Box>
                            <Typography variant='h6'>Run Data Cleanup</Typography>
                        </Box>
                        <Box>
                            <Button variant="contained" disabled={dataCleanupRunning} onClick={runDataCleanup}>Submit</Button>
                        </Box>
                        <Box>
                            <BeatLoader
                                loading={dataCleanupRunning}
                                size={24}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </Box>
                    </Stack>
                </Box>
                <Box>
                    <Stack spacing={1}>
                        <Box>
                            <Typography variant='h6'>Synchronize Data</Typography>
                        </Box>
                        <Box>
                            <TextField id="sync-artist" label="Sync Artist Name" variant="outlined" value={syncArtist}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSyncArtist(event.target.value)} />
                        </Box>
                        <Box>
                            <Button variant="contained" disabled={syncing} onClick={submitSyncronizeArtistData}>Submit</Button>
                        </Box>
                        <Box>
                            {synchronizeCount === 0 ? '' : synchronizeCount}
                            <BeatLoader
                                loading={syncing}
                                size={24}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </Box>
                    </Stack>
                </Box>
                <Box>
                    <Stack spacing={1}>
                        <Box>
                            <Typography variant='h6'>Fix Similar Name Data</Typography>
                        </Box>
                        <Box>
                            <TextField id="old-name" label="Incorrect Artist Name" variant="outlined" value={oldName}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setOldName(event.target.value)} />
                        </Box>
                        <Box>
                            <TextField id="new-name" label="Correct Artist Name" variant="outlined" value={newName}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setNewName(event.target.value)} />
                        </Box>
                        <Box>
                            <Button variant="contained" disabled={fixing} onClick={submitFixSimilarArtistNameAsync}>Submit</Button>
                        </Box>
                        <Box>
                            <BeatLoader
                                loading={fixing}
                                size={24}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                            {similarArtists.map((artist: string, index: number) =>
                                <Box key={`artist-${index}`}>
                                    {artist}
                                </Box>
                            )}
                        </Box>
                    </Stack>
                </Box>
                <Box>
                    <Stack spacing={1}>
                        <Box>
                            <Typography variant='h6'>Delete Artist Data</Typography>
                        </Box>
                        <Box>
                            <TextField id="delete-letter" label="Delete Artist Letter" variant="outlined" value={delLetter}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setDelLetter(event.target.value)} />
                        </Box>
                        <Box>
                            <TextField id="delete-artist" label="Delete Artist Name" variant="outlined" value={delArtist}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setDelArtist(event.target.value)} />
                        </Box>
                        <Box>
                            <Button variant="contained" disabled={deleting} onClick={submitDeleteArtistData}>Submit</Button>
                        </Box>
                        <Box>
                            {deleteCount === 0 ? '' : deleteCount}
                            <BeatLoader
                                loading={deleting}
                                size={24}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </Box>
                    </Stack>
                </Box>
            </Stack>
        </>
    );
}

export default Admin;